export class Paging {
    static readonly FIRST_PAGE: number = 1;
}
